import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { COLOR_GREY_5, COLOR_GREY_7 } from "shared/theme/colors";
import { flexColumn, border, flex } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  ${flex({ ai: "center" })};
  height: 22px;
  width: fit-content;
  column-gap: 4px;
  padding: 0 6px;
  border-radius: 0.5rem;
  ${border(1, COLOR_GREY_5)}
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
`;

export const StyledDot = styled(Box, {
  shouldForwardProp: (props) => props !== "bgColor",
})<{
  bgColor?: string;
}>`
  ${flexColumn({ ai: "center" })};
  background-color: ${({ bgColor }) => bgColor || COLOR_GREY_7};
  height: 8px;
  width: 8px;
  border-radius: 50%;
`;
